import styled from "styled-components";
import { Divider, ListItemText, Typography } from "@mui/material";
import { OuterWrapper } from "../wrapper/wrapper";

export const MainContainer = styled(OuterWrapper)`
  && {
    background: linear-gradient(90deg, #3cf0f1 0%, #03424a 100%);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
  }
`;

export const CompanyName = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 400;
    font-size: 48px;
    line-height: 50px;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
`;

export const AboutCompany = styled(Typography)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 25px;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
`;

export const Title = styled(Typography)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 29px;
    letter-spacing: 0.05em;
    color: #ffffff;
    border-bottom: 1px solid #ffffff;
    padding-bottom: 10px;
  }
`;

export const ListText = styled(ListItemText)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
`;

export const HrLine = styled(Divider)`
  && {
    width: 100%;
    height: 1px;
    background-color: white;
  }
`;

export const CopyrightText = styled(Typography)`
  && {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    text-align: center;
    line-height: 18px;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
`;
